module.exports = __webpack_public_path__ + "img/img2.f23b3150.jpg";